var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 7.99992C8.84089 7.99992 10.3333 6.50753 10.3333 4.66659C10.3333 2.82564 8.84089 1.33325 6.99996 1.33325C5.15901 1.33325 3.66663 2.82564 3.66663 4.66659C3.66663 6.50753 5.15901 7.99992 6.99996 7.99992Z",
    stroke: "#777777",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7267 14.6667C12.7267 12.0867 10.1601 10 7.00013 10C3.8401 10 1.27344 12.0867 1.27344 14.6667",
    stroke: "#777777",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/personIcon.6f8e05e2aa6d36d8d513922df7054b37.svg";
export { ForwardRef as ReactComponent };